import { Link } from "react-router-dom"

const Home = () => {
    return (
        <div id="home" style={{ color: 'black', display: 'flex', flexDirection: 'column', gap: '20px', padding: '20px' }}>
          <Link to="/pages">金馬60 – 致電影聲音故事互動</Link>
          <Link to="/pages/points">金馬60 – 致電影聲音故事互動 | 集點卡</Link>
          <Link to="/coupon/list">金馬60 – 致電影聲音故事互動｜優惠券</Link>
        </div>
    )
}

export default Home